var _rect, _g, _g2, _g3, _g4, _path, _use, _use2, _path2, _use3, _use4, _use5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _g5, _use6, _use7, _use8, _use9, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCskhBotMsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_22134_57499)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_22134_57499)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_22134_57499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7952 15.8245C32.5762 15.8245 33.2892 15.6069 33.88 15.0969C33.88 15.0969 35.7339 12.7512 35.1771 11.7721C35.0888 11.6157 34.8375 11.4798 34.4165 11.4118C29.6425 10.6435 28.0195 16.8307 28.0195 16.8307C28.0195 16.8307 28.4202 17.3271 29.174 17.7282C29.174 17.7282 31.5983 19.1221 32.8275 18.8637C33.5948 18.7005 33.5812 18.1158 33.4658 17.6942C32.9633 17.7554 32.5761 17.4912 32.0533 17.2455C32.5354 17.4019 32.9836 17.6126 33.4862 17.6806C35.4623 16.6676 33.8732 15.1037 33.8732 15.1037C33.4077 15.6178 32.5761 16.0341 31.7885 15.8313L31.7952 15.8245Z",
    fill: "url(#paint1_linear_22134_57499)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_22134_57499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03874 15.8303C7.25779 15.8303 6.54475 15.6127 5.95395 15.1028C5.95395 15.1028 4.10005 12.7571 4.6569 11.778C4.74518 11.6216 4.99644 11.4856 5.41747 11.4176C10.1914 10.6493 11.8145 16.8366 11.8145 16.8366C11.8145 16.8366 11.4138 17.3329 10.66 17.7341C10.66 17.7341 8.23567 19.1279 7.00653 18.8696C6.23916 18.7064 6.25275 18.1216 6.36819 17.7001C6.87072 17.7613 7.25789 17.4971 7.78069 17.2513C7.29854 17.4077 6.85034 17.6185 6.34782 17.6865C4.37168 16.6734 5.96074 15.1096 5.96074 15.1096C6.42629 15.6237 7.25789 16.04 8.04553 15.8371L8.03874 15.8303Z",
    fill: "url(#paint2_linear_22134_57499)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_22134_57499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.093 18.911C32.093 20.0043 31.3828 20.9243 30.413 21.2088C30.237 21.2603 30.0521 21.2914 29.8628 21.2985C29.8352 21.2985 29.8068 21.3003 29.7792 21.3003C29.7561 21.3003 29.7321 21.3003 29.709 21.2977C29.6032 21.2959 29.4983 21.2852 29.3961 21.2674C29.4326 21.0603 29.437 20.8701 29.445 20.6408C29.5117 18.6301 29.3454 17.4123 29.125 16.6203C29.3321 16.5563 29.5517 16.5234 29.7792 16.5234C31.0566 16.5234 32.093 17.5919 32.093 18.911Z",
    fill: "url(#paint3_linear_22134_57499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 18.911C6.8125 20.0043 7.52272 20.9243 8.4925 21.2088C8.69428 21.2692 8.90761 21.3003 9.12628 21.3003C9.14939 21.3003 9.17339 21.3003 9.19561 21.2985C9.30139 21.2968 9.40628 21.2861 9.5085 21.2683C9.47206 21.0612 9.46761 20.871 9.45961 20.6417C9.39294 18.6301 9.55917 17.4123 9.77961 16.6203C9.5725 16.5572 9.35294 16.5234 9.12539 16.5234C7.84894 16.5234 6.8125 17.5928 6.8125 18.911Z",
    fill: "url(#paint4_linear_22134_57499)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_iii_22134_57499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5273 18.6717C29.3918 15.3123 27.4464 12.8215 24.0436 11.6678C22.6269 11.1859 21.1221 10.9688 19.1767 10.9688C17.0483 10.9688 14.9674 11.6474 14.3776 11.851C11.7951 12.7605 10.0462 14.8033 9.57175 17.4569C9.43618 18.2034 9.36162 18.9703 9.34128 19.7372C9.32772 20.4091 9.35484 21.081 9.42262 21.7597C9.44973 22.0379 9.4904 22.3094 9.53107 22.5877C10.0327 25.7299 12.2357 27.9899 15.5842 28.7908C16.6891 29.0487 17.8617 29.1776 19.17 29.1776C19.8139 29.1776 20.4714 29.1505 21.3187 29.0894C22.4439 29.0012 23.6369 28.7365 24.7689 28.3157C27.365 27.3655 29.1478 25.1191 29.4257 22.4587C29.446 22.2551 29.4663 22.0447 29.4799 21.8343C29.5273 21.1896 29.5545 20.5177 29.5545 19.8187C29.5545 19.4454 29.5409 19.0653 29.5273 18.6717Z",
    fill: "url(#paint5_linear_22134_57499)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dif_22134_57499)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_22134_57499",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_22134_57499",
    fill: "url(#paint6_radial_22134_57499)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1413 19.786C25.0803 18.2406 24.2601 17.4339 22.7214 16.912C21.7521 16.5866 20.6811 16.4375 19.156 16.4375C17.8952 16.4375 16.4243 16.8442 15.7193 17.0882C14.7229 17.4407 14.0789 18.1592 13.8959 19.176C13.6722 20.43 13.6722 21.6975 13.8688 22.9515C14.0925 24.375 15.116 25.1003 16.4988 25.4256C18.0036 25.7849 19.5356 25.7375 21.0539 25.6222C21.8402 25.5612 22.6401 25.3646 23.3789 25.0935C24.3143 24.7478 24.9515 24.0429 25.0532 23.0803C25.1684 21.989 25.182 20.8773 25.1413 19.7725V19.786Z",
    fill: "url(#paint7_linear_22134_57499)",
    strokeWidth: 0.267542,
    stroke: "url(#paint8_linear_22134_57499)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_22134_57499",
    fill: "#848484"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_22134_57499",
    fill: "url(#paint9_linear_22134_57499)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4424 23.5283C19.8108 23.5283 20.128 23.7447 20.2764 24.0566C20.129 24.3709 19.8115 24.5897 19.4414 24.5898C19.0727 24.5898 18.7556 24.3729 18.6074 24.0605C18.7549 23.7467 19.0726 23.5285 19.4424 23.5283Z",
    fill: "url(#paint10_linear_22134_57499)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_22134_57499",
    fill: "#474747"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_22134_57499",
    fill: "url(#paint11_radial_22134_57499)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_22134_57499",
    fill: "url(#paint12_radial_22134_57499)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3125,
    y: 20.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "#474747"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3125,
    y: 20.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "url(#paint13_radial_22134_57499)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.959,
    y: 20.0918,
    width: 0.646633,
    height: 0.646633,
    fill: "#474747"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.959,
    y: 20.0918,
    width: 0.646633,
    height: 0.646633,
    fill: "url(#paint14_radial_22134_57499)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6035,
    y: 20.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "#474747"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6035,
    y: 20.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "url(#paint15_radial_22134_57499)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5214,
    cy: 22.4953,
    r: 0.297268,
    transform: "rotate(-4.21204 15.5214 22.4953)",
    fill: "url(#paint16_linear_22134_57499)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3906,
    cy: 22.4836,
    r: 0.297268,
    transform: "rotate(-4.21204 23.3906 22.4836)",
    fill: "url(#paint17_linear_22134_57499)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_iii_22134_57499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3368 27.6834C22.208 28.1652 22.0454 28.6471 21.8488 29.1222C21.8013 29.2308 21.6929 29.3122 21.5573 29.3393C20.161 29.604 18.7307 29.604 17.3344 29.3393C17.1988 29.3122 17.0904 29.2308 17.0429 29.1222C16.8463 28.6471 16.6837 28.1652 16.5549 27.6834C16.4939 27.4458 16.7243 27.2422 16.9548 27.3101C18.5816 27.7512 20.2965 27.7512 21.9234 27.3101C22.1606 27.2422 22.3843 27.4458 22.3233 27.6834H22.3368Z",
    fill: "url(#paint18_linear_22134_57499)"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke3_22134_57499",
    fill: "#595959"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke3_22134_57499",
    fill: "url(#paint19_linear_22134_57499)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_22134_57499",
    fill: "#595959"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_22134_57499",
    fill: "url(#paint20_linear_22134_57499)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_22134_57499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0123 21.2666C29.3579 23.2218 27.822 24.051 26.4567 24.3892C25.7326 24.5679 25.0462 24.6122 24.541 24.6122C24.2885 24.6122 24.081 24.6011 23.935 24.5891C23.8621 24.5836 23.8055 24.5781 23.7661 24.5744C23.7464 24.5716 23.7309 24.5698 23.7202 24.5688C23.7153 24.5688 23.7112 24.5688 23.7079 24.567H23.7038C23.7038 24.567 23.7038 24.567 23.7046 24.555L23.703 24.5661C23.5906 24.5513 23.5111 24.4362 23.525 24.3099C23.5381 24.1837 23.6406 24.0934 23.753 24.1091H23.7555C23.7555 24.1091 23.7604 24.1091 23.7653 24.1109C23.7743 24.1109 23.7874 24.1137 23.8055 24.1155C23.8416 24.1192 23.8949 24.1247 23.9629 24.1303C24.1007 24.1404 24.2991 24.1515 24.541 24.1515C25.0265 24.1515 25.6817 24.1091 26.3689 23.9386C27.635 23.6254 28.9142 22.891 29.5234 21.2344C29.6177 21.2528 29.7729 21.2639 29.8705 21.2657C29.8918 21.2685 29.9139 21.2685 29.9352 21.2685C29.9607 21.2685 29.9869 21.2675 30.0123 21.2666Z",
    fill: "url(#paint21_linear_22134_57499)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_22134_57499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9954 23.2031H22.204C21.608 23.2031 21.125 23.6869 21.125 24.2838C21.125 24.8807 21.608 25.3645 22.204 25.3645H22.9954C23.5914 25.3645 24.0744 24.8807 24.0744 24.2838C24.0744 23.6869 23.5914 23.2031 22.9954 23.2031Z",
    fill: "url(#paint22_linear_22134_57499)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_22134_57499",
    x: 4.55273,
    y: 11.3457,
    width: 30.7285,
    height: 8.15488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.599213
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.299607
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_22134_57499",
    x: 27.2923,
    y: 9.89116,
    width: 7.98899,
    height: 9.73162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.727273,
    dy: 0.727273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.363636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.727273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_57499",
    result: "effect2_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_22134_57499",
    x: 3.82546,
    y: 9.89702,
    width: 7.98899,
    height: 9.73162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.727273,
    dy: 0.727273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.363636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.727273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_57499",
    result: "effect2_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_22134_57499",
    x: 6.8125,
    y: 16.1679,
    width: 25.2803,
    height: 5.6329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.346229 0 0 0 0 0.346229 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.355556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150222 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_57499",
    result: "effect2_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_iii_22134_57499",
    x: 9.33789,
    y: 10.0632,
    width: 20.2168,
    height: 20.2465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.679156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.905541
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.905541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.775729 0 0 0 0 0.439322 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_57499",
    result: "effect2_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13193
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_57499",
    result: "effect3_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dif_22134_57499",
    x: 11.1267,
    y: 12.527,
    width: 16.039,
    height: 14.8174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.399476,
    dy: -1.19843
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.599213
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22134_57499",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.399476,
    dy: 0.399476
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.399476
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.507625 0 0 0 0 0.507625 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.499345,
    result: "effect3_foregroundBlur_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_iii_22134_57499",
    x: 16.5449,
    y: 26.6177,
    width: 5.79199,
    height: 3.59952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.679156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.905541
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.679156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.679156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.855364 0 0 0 0 0.638409 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_57499",
    result: "effect2_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.452771
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.679156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_57499",
    result: "effect3_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_22134_57499",
    x: 23.5234,
    y: 20.8344,
    width: 6.48926,
    height: 3.77793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.346229 0 0 0 0 0.346229 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150222 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_57499",
    result: "effect2_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_22134_57499",
    x: 21.125,
    y: 22.8031,
    width: 2.94922,
    height: 2.56113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.346229 0 0 0 0 0.346229 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_57499"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150222 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_57499",
    result: "effect2_innerShadow_22134_57499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22134_57499",
    x1: 17.68,
    y1: -31.9444,
    x2: 68.8962,
    y2: 7.17142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22134_57499",
    x1: 31.9442,
    y1: 12.1028,
    x2: 31.9403,
    y2: 19.3755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22134_57499",
    x1: 7.88974,
    y1: 12.1087,
    x2: 7.89364,
    y2: 19.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22134_57499",
    x1: 29.125,
    y1: 21.279,
    x2: 29.125,
    y2: 15.9901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22134_57499",
    x1: 6.8125,
    y1: 21.279,
    x2: 6.8125,
    y2: 15.9901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22134_57499",
    x1: 19.4443,
    y1: 12.941,
    x2: 19.4443,
    y2: 30.1864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_22134_57499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.6608 2.7363 -3.22027 -8.2089 23.7516 18.5748)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22134_57499",
    x1: 19.4555,
    y1: 15.9975,
    x2: 19.6962,
    y2: 26.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366298,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22134_57499",
    x1: 15.5015,
    y1: 15.8555,
    x2: 22.0384,
    y2: 25.9202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322115,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595864,
    stopColor: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#FFF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22134_57499",
    x1: 19.4415,
    y1: 22.8838,
    x2: 19.4415,
    y2: 24.1772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE4D50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22134_57499",
    x1: 19.4422,
    y1: 22.6976,
    x2: 19.4422,
    y2: 24.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_22134_57499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.12532 0.764831 -0.375108 -2.29449 17.1126 20.1631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_22134_57499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.12532 0.764831 -0.375108 -2.29449 17.1126 20.1631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_22134_57499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8429 20.943) rotate(161.565) scale(0.489864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_22134_57499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4894 20.2985) rotate(161.565) scale(0.489864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_22134_57499",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.134 20.943) rotate(161.565) scale(0.489864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22134_57499",
    x1: 15.5214,
    y1: 22.1981,
    x2: 15.5214,
    y2: 22.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22134_57499",
    x1: 23.3906,
    y1: 22.1863,
    x2: 23.3906,
    y2: 22.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_22134_57499",
    x1: 19.4461,
    y1: 27.2782,
    x2: 19.4461,
    y2: 33.3037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22134_57499",
    x1: 18.0282,
    y1: 11.846,
    x2: 17.6978,
    y2: 15.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_22134_57499",
    x1: 17.9453,
    y1: 12.8259,
    x2: 17.7429,
    y2: 15.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_22134_57499",
    x1: 23.5234,
    y1: 24.5971,
    x2: 23.5234,
    y2: 20.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_22134_57499",
    x1: 21.125,
    y1: 25.3548,
    x2: 21.125,
    y2: 22.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "stroke0_22134_57499",
    d: "M19.1695 26.3459C18.1324 26.3459 17.2173 26.2509 16.37 26.0473C13.8417 25.4433 13.0757 23.8484 12.8792 22.6132C12.6623 21.2627 12.6758 19.9121 12.9063 18.6158C13.1639 17.177 14.0857 16.1115 15.5024 15.6093C15.8278 15.4939 17.5427 14.9238 19.1763 14.9238C20.7624 14.9238 21.8944 15.0799 22.9586 15.4396C25.0261 16.1387 26.0632 17.4281 26.1445 19.3692C26.1919 20.5636 26.1648 21.6427 26.0564 22.6675C25.914 24.052 24.9922 25.1786 23.6026 25.6876C22.7553 25.9998 21.8741 26.1966 21.0607 26.2577C20.3083 26.312 19.7253 26.3391 19.1695 26.3391V26.3459ZM17.9291 21.9888C17.9291 21.9888 17.963 21.9956 17.9833 22.0024Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke1_22134_57499",
    d: "M18.5176 22.4932C18.5176 22.3772 18.6116 22.2832 18.7276 22.2832H20.1554C20.2714 22.2832 20.3654 22.3772 20.3654 22.4932V23.6691C20.3654 24.1794 19.9518 24.593 19.4415 24.593V24.593C18.9312 24.593 18.5176 24.1794 18.5176 23.6691V22.4932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke2_22134_57499",
    d: "M17.3939 19.7797V21.698C17.3939 22.0505 17.1092 22.3352 16.7568 22.3352H16.4721C16.1196 22.3352 15.8281 22.0505 15.8281 21.698V20.5999H16.3772V20.0509H16.9262V19.5018H16.3772V20.0509H15.8281V19.7797C15.8281 19.4273 16.1196 19.1426 16.4721 19.1426H16.7568C17.1092 19.1426 17.3939 19.4273 17.3939 19.7797Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke3_22134_57499",
    d: "M20.7232 14.452C20.4114 14.452 20.391 14.4384 20.3368 14.1466C20.147 13.0743 19.2726 12.4906 18.3101 12.3074C18.2423 12.2938 18.1677 12.287 18.0999 12.2803C17.8356 12.2395 17.8559 12.1038 17.8627 12.0563C17.8627 11.9816 17.8627 11.9138 17.8898 11.8391C17.9237 11.7102 18.0525 11.717 18.1135 11.7237C19.4217 11.8323 20.3842 12.3821 20.9062 13.5765C20.9807 13.7462 21.0146 13.9294 21.0485 14.1059C21.1095 14.4113 21.0621 14.452 20.7367 14.452H20.7232Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke4_22134_57499",
    d: "M19.4827 14.4452C19.1913 14.4452 19.198 14.4452 19.1303 14.1805C19.0082 13.7394 18.6897 13.4815 18.2423 13.3457C18.2016 13.3322 18.1542 13.3254 18.1135 13.3186C17.8559 13.2643 17.8152 13.2168 17.8491 12.9792C17.8695 12.8367 17.944 12.7553 18.1067 12.7485C18.7371 12.7349 19.198 13.0335 19.5437 13.495C19.6996 13.6986 19.7878 13.9497 19.8555 14.2144C19.8894 14.357 19.8216 14.4384 19.6522 14.4452C19.598 14.4452 19.5437 14.4452 19.4895 14.4452H19.4827Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCskhBotMsg);
export default __webpack_public_path__ + "static/media/ic-cskh-bot-msg.7912552b7237568c2856a637f3ba1de6.svg";
export { ForwardRef as ReactComponent };